export const HELP_URL = 'https://help.timelog.com';
